import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  inject,
  Input,
  Output,
} from "@angular/core";

import { MonthlySummaryService } from "@bitwarden/web-vault/app/services/monthly-summary/monthly-summary.service";

import { GlossRoutes, NavItem } from "../../../models/enum/routes.enum";

export interface MoreTool {
  key: string;
  /** Sprite icon id. */
  icon: string;
  /** i18n key. */
  label: string;
}

@Component({
  selector: "app-more-overview",
  templateUrl: "./more-overview.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MoreOverviewComponent {
  @Input() pinnedItems: NavItem[] = [];
  @Input() otherItems: NavItem[] = [];
  @Input() tools: MoreTool[] = [];
  @Output() toolSelected = new EventEmitter<MoreTool>();
  @Output() itemSelected = new EventEmitter<NavItem>();
  @Output() monthlySummarySelected = new EventEmitter<void>();
  @Output() editNavigation = new EventEmitter<void>();
  @Output() closed = new EventEmitter<void>();

  private monthlySummaryService = inject(MonthlySummaryService);

  protected readonly GlossRoutes = GlossRoutes;

  /** otherItems minus anything already surfaced in "Your tools" (e.g. Grocery), so it isn't listed twice. */
  protected gridItems(): NavItem[] {
    return this.otherItems.filter((item) => !this.tools.some((tool) => tool.key === item.key));
  }

  protected hasSettingsInOtherItems(): boolean {
    return this.otherItems.some((item) => item.key === GlossRoutes.Settings);
  }

  protected monthlySummaryEnabled(): boolean {
    return this.monthlySummaryService.enabled;
  }
}
